import React, { Component } from 'react';
import Web3 from 'web3'
import Lott from '../abis/mini_lottery.json'
import logo from '../lott_anim.gif';
import './App.css';




////////////////////////////////////////////////////////////////////////////////////////


class App extends Component {





  async componentWillMount() {
    await this.loadWeb3()
    if(this.state.Web3Status)
      await this.loadBlockchainData()
  }

  componentDidMount() {
    this.interval = setInterval(() => { 
      if (this.state.Family != null){
        this.updateContractInfo()
        //console.log('time update')
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  async loadBlockchainData() {
    const web3 = window.web3
    const accounts = await web3.eth.getAccounts()
    console.log('account address: ' + accounts)
    this.setState({ account: accounts[0] })

    const networkId = await web3.eth.net.getId()
    console.log('network id: '+ networkId)
    const networkData = Lott.networks[networkId]
    if(networkData) {
      try{
          const family = web3.eth.Contract(Lott.abi, networkData.address)
          this.setState({Family: family})
          console.log('contract address: ' + family.address)

          this.updateState(family, true)

          this.setState({ContractStatus: true})

        }catch(e){
          this.setState({ContractStatus: false})
          console.error(e.message);
          window.alert('Sorry for contract retrieval error.')
        }
      
    } else {
      this.setState({ContractStatus: false})
      window.alert('Contract is not deployed to detected network.')
    }
  }

  async updateState(family, showLog){
    let account = this.state.account
    const withdrawable = await family.methods.check_withdraw(account).call()
    if(showLog) console.log('withdrawable: ' + withdrawable.toString())
    this.setState({Withdrawable: Boolean(withdrawable)})

    const owner = await family.methods.getOwner().call()
    if(showLog) console.log('owner: ' + owner.toString())
    let isOwner = false
    if(owner.toString() === account.toString()) isOwner = true
    this.setState({IsOwner: isOwner.toString()})

    if(isOwner.toString() === 'true'){
      const balance = await family.methods.get_balance().call() * 1.0e-18
      if(showLog) console.log('contract balance: ' + balance.toString())
      this.setState({ContractBalance: balance.toString()})
    }

    const reward = await family.methods.get_remain_reward().call() * 1.0e-18
    this.setState({Reward:  reward.toString()})

    const reward2 = await family.methods.get_total_reward().call() * 1.0e-18
    this.setState({TotalPrize:  reward2.toString()})

    const commision = await family.methods.get_commision().call() * 1.0e-18
    this.setState({Commision:  commision.toString()})
    if(showLog) console.log('commision: ' + commision.toString())

    const commitable = await family.methods.check_commitable(account).call()
    if(showLog) console.log('commitable: ' + commitable.toString())
    this.setState({Commitable: Boolean(commitable)})

    const revealable = await family.methods.check_revealable(account).call()
    if(showLog) console.log('revealable: ' + revealable.toString())
    this.setState({Revealable: Boolean(revealable)})
    
  }

  async loadWeb3() {
    if (window.ethereum) {
      window.web3 = new Web3(window.ethereum)
      await window.ethereum.enable()
      this.setState({Web3Status: true})
    }
    else if (window.web3) {
      window.web3 = new Web3(window.web3.currentProvider)
      this.setState({Web3Status: true})
    }
    else {
      this.setState({Web3Status: false})
      window.alert('Non-Ethereum browser detected. You should consider trying MetaMask!')
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      Web3Status: false,
      ContractStatus: false,
      account: '',
      Family: null,      
  
      Commit_value: 0.1,
      Reward: 0,
      TotalPrize: 0,

      Message: '',
      IsOwner: false,
      ContractBalance: 0,
      Withdrawable: false,
      Commision:0, 

      Commited: false,
      Status: 0, //0: idle, 1: commited, 2: revealed
      Commitable: true,
      Revealable: false,

      NewOwner: '',

      EMPTY_ADDRESS:'0x0000000000000000000000000000000000000000',
    }
  }


  async btnRevealClick(){
    this.setState({Message:''})

    //TODO: check if it is committed

    //if (this.state.Joined === "false"){
    //  window.alert('You did NOT joined any family.')
    //  return
    //}

    //if (!window.web3.utils.isAddress(this.state.ChildAddress)){
    //  window.alert('Invalid child address!')
    //  return
    //}

    if (!this.state.ContractStatus){
      window.alert('Contract is not ready! Please wait or check errors.')
      return
    }

    if (this.state.Family != null){
      this.setState({Message:'Reveal in processing , please waiting ......' })
      await this.state.Family.methods.reveal().send({from: this.state.account})
        .on('transactionHash', (hash) => {
            console.log('CREATING hash:', hash)
            //window.alert('Tx hash: ' + hash)
            })
        .on('confirmation', (confirmationNumber, receipt) => {
              console.log('CONFIRMATION receipt:', confirmationNumber, receipt)
              
              //window.alert('Congrats! Sponsor is confirmed and you could win 50 ETH!')
              if (this.state.Status === 1) {
                this.setState({Status: 2})
                this.setState({Message:'Congrats! You have successfully revealed your bet. You could withdraw the prize.' })
              }

              if (receipt.Created) {
                let res = receipt.events['Created'].returnValues['feed']
                console.log('this is res: ', res)
              }
              
        })
        .on('error', function (error) { 
          console.log("ERROR: ", error.message); 
          window.alert('Sorry for an unexpected error. Tx is reverted!');
          
        })
        

      
    }
  }


async btnCommitClick(bet_value){
  this.setState({Message:''})

  //if (this.state.Joined === "true"){
  //    window.alert('You have already joined.')
  //    return
  //}

  if (this.state.Commit_value <= 0){
    window.alert('Invalid commit value!')
    return
  }

  if (!this.state.ContractStatus){
    window.alert('Contract loading error! Please clean your wallet cache and try it again.')
    return
  }

  if (this.state.Family != null){
    //TODO: check if it is still not revealed
    //const parent_exists = await this.state.Family.methods.checkParentExist(parent_address).call()
    //if(parent_exists === 'false'){
    //  window.alert('The input parent does NOT exist!')
    //  return
    //}

    console.log('commit with ' + bet_value + ' ETH')

    if (window.confirm('Are you sure to commit ' + bet_value + ' ETH?')){      
        this.setState({Message:'Commit in processing, please waiting ...'})
        await this.state.Family.methods.commit().send({from: this.state.account, value: (bet_value * 1.0e18)})
                                          .on('transactionHash', (hash) => {
                                              console.log('CREATING hash:', hash)
                                              //window.alert('Tx hash: ' + hash)
                                              })
                                          .on('confirmation', (confirmationNumber, receipt) => {
                                                console.log('CONFIRMATION receipt:', confirmationNumber, receipt)
                                                
                                                //window.alert('Congrats! Sponsor is confirmed and you could win 50 ETH!')
                                                if (this.state.Status !== 1){
                                                  this.setState({Status: 1})
                                                  this.setState({Message:'Congrats! You have successfully committed ' + bet_value + ' ETH.'})
                                                } 
                                                
                                          })
                                          .on('error', function (error) { 
                                            console.log("ERROR: ", error.message); 
                                            window.alert('Sorry for an unexpected error. Tx is reverted!');
                                            
                                          })                    
    }
  }
}

async btnWithdrawClick(){
  this.setState({Message:''})
  
  if (!this.state.ContractStatus){
    window.alert('Contract loading error! Please clean your wallet cache and try it again.')
    return
  }
  
  if (this.state.Family != null){
      this.setState({Message:'Please waiting ...'})
      await this.state.Family.methods.withdraw().send({from: this.state.account})
                                          .on('transactionHash', (hash) => {
                                              console.log('CREATING hash:', hash)
                                              //window.alert('Tx hash: ' + hash)
                                              })
                                          .on('confirmation', (confirmationNumber, receipt) => {
                                                console.log('CONFIRMATION receipt:', confirmationNumber, receipt)
                                                
                                                //window.alert('Congrats! Sponsor is confirmed and you could win 50 ETH!')
                                                this.setState({Message:'withdraw done! ' })
                                                //if (this.state.Status == 2) this.setState({Status: 0})
                                                
                                          })
                                          .on('error', function (error) { 
                                            console.log("ERROR: ", error.message); 
                                            window.alert('Sorry for an unexpected error. Tx is reverted!')
                                            
                                          })                    
    
  }
}

async btnOwnerWithdrawClick(){
    this.setState({Message:''})

    if (!this.state.ContractStatus){
      window.alert('Contract loading error! Please clean your wallet cache and try it again.')
      return
    }

    if(this.state.IsOwner !== 'true'){
      window.alert('You have no withdraw right.')
      return
    }

    if (this.state.Family != null){
        this.setState({Message:'Please waiting ...'})
        await this.state.Family.methods.withdraw_commision_fee().send({from: this.state.account})
                                            .on('transactionHash', (hash) => {
                                                console.log('CREATING hash:', hash)
                                                //window.alert('Tx hash: ' + hash)
                                                })
                                            .on('confirmation', (confirmationNumber, receipt) => {
                                                  console.log('CONFIRMATION receipt:', confirmationNumber, receipt)
                                                  
                                                  //window.alert('Congrats! Sponsor is confirmed and you could win 50 ETH!')
                                                  this.setState({Message:'withdraw done! ' })
                                                  
                                            })
                                            .on('error', function (error) { 
                                              console.log("ERROR: ", error.message); 
                                              window.alert('Sorry for an unexpected error. Tx is reverted!')
                                              
                                            })                    
      
    }
}

async btnChangeOwnerClick(){
  this.setState({Message:''})

  if (!this.state.ContractStatus){
    window.alert('Contract loading error! Please clean your wallet cache and try it again.')
    return
  }

  if(this.state.IsOwner !== 'true'){
    window.alert('You are not owner.')
    return
  }

  if (!window.web3.utils.isAddress(this.state.NewOwner)){
    window.alert('Not valid address.')
    return
  }

  if (this.state.Family != null){
      this.setState({Message:'Please waiting ...'})
      await this.state.Family.methods.changeOwner(this.state.NewOwner).send({from: this.state.account})
                                          .on('transactionHash', (hash) => {
                                              console.log('CREATING hash:', hash)
                                              //window.alert('Tx hash: ' + hash)
                                              })
                                          .on('confirmation', (confirmationNumber, receipt) => {
                                                console.log('CONFIRMATION receipt:', confirmationNumber, receipt)
                                                
                                                //window.alert('Congrats! Sponsor is confirmed and you could win 50 ETH!')
                                                this.setState({Message:'Owner is changed! ' })
                                                
                                          })
                                          .on('error', function (error) { 
                                            console.log("ERROR: ", error.message); 
                                            window.alert('Sorry for an unexpected error. Tx is reverted!')
                                            
                                          })                    
    
  }
}

  refInputHandler = (event) => {
    this.setState({Commit_value: event.target.value});
  }

  newOwnerInputHandler = (event) => {
    this.setState({NewOwner: event.target.value});
  }

  async updateContractInfo(){
      if(!this.state.ContractStatus)
        return;

      this.updateState(this.state.Family, false)

  }

  render() {
    return (
      <div>
        <nav className="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
          <a
            className="navbar-brand col-sm-3 col-md-2 mr-0"
            href="https://dappradar.com/app/1880/lucky-crypto-paintings"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instant Lott
          </a>
        </nav>
        <div className="container-fluid mt-5">
          <div className="row">
            <main role="main" className="col-lg-12 d-flex text-center">
              <div className="content mr-auto ml-auto">
  
                <h1><img src={logo} className="App-logo" alt="logo" /></h1>
                <hr/>
                <p align="left"><font size="5">Welcome to Instant Lott! Win the lottery prize with 100% possibility.  </font></p>
                <p align="left"><font size="5">~ Features:</font></p>
                <p align="left"><font size="4">1) The code of smart contract is public. It's secure and transparent. 2) Advanced random generation prevents mining tampering. 3) Get the prize instantly.</font></p>
                <p align="left"><font size="5">~ It's very easy to start:</font></p>
                <p align="left"><font size="4">1) Commit bet value; 2) reveal results; 3) withdraw prize.</font></p>
                <p align="left"><font size="5">~ Note:  </font></p>
                <p align="left"><font size="4">   1) Bet value range: 0.01 ~ 0.1 ETH; 2) Max. prize: 1000 ETH with chance of 1/888888; 3) 90% of all income goes to prize pool. </font></p>
                <p align="left"><font size="4">    </font></p>
                <p align="left"><font size="4">    </font></p>
                <hr/>
                <div className="Draw_Items"> 
                  <ul>
                    <p align="left"><font size="5">Your prize to withdraw: {this.state.ContractStatus ? this.state.Reward: "0"} ETH / Total prize: {this.state.ContractStatus ? this.state.TotalPrize: "0"} ETH</font></p>
                    <p align="left"><font size="5">Your address: {this.state.ContractStatus ? this.state.account: "?"}</font></p>                   

                    <span>&nbsp;&nbsp;</span>
                    <p align="left">Message: {this.state.ContractStatus ? this.state.Message: ""}</p> 
                    <hr/>

                    <p align="left">Enter bet value: <input type="text"  style={{width: "100px"}} onChange={this.refInputHandler}/> ETH
                      &nbsp;&nbsp;&nbsp;<button disabled={this.state.Commitable===false} style={{width: "150px"}} onClick={this.btnCommitClick.bind(this, this.state.Commit_value)}> Commit Bet </button>
                    </p>
                    
                    <p align="left">Reveal your bet: 
                      &nbsp;&nbsp;&nbsp;<button disabled={this.state.Revealable===false} style={{width: "150px"}} onClick={this.btnRevealClick.bind(this)}> Reveal</button>
                    </p>

                    <p align="left">Withdraw prize: 
                      &nbsp;&nbsp;&nbsp;<button disabled={this.state.Withdrawable===false} style={{width: "150px"}} onClick={this.btnWithdrawClick.bind(this)}> Withdraw</button>
                    </p>
                    <hr/>

                    <span>&nbsp;&nbsp;</span>
                    <hr/>
                  
                    <p align="left">{this.state.IsOwner==='true'? 'contract balance: ' + this.state.ContractBalance + ' ETH': ' '}</p>
                    <p align="left">{this.state.IsOwner==='true'? 'commision income: ' + this.state.Commision + ' ETH': ' '}</p>
                    <p align="left">{this.state.IsOwner==='true' && <button style={{width: "150px"}} onClick={this.btnOwnerWithdrawClick.bind(this)}>Withdraw</button>}</p>
                        
                    <p align="left">{this.state.IsOwner==='true' && 'New owner address:' && <input type="text"  style={{width: "500px"}} onChange={this.newOwnerInputHandler}/>}
                    </p>
                    <p align="left">{this.state.IsOwner==='true' && <button style={{width: "150px"}} onClick={this.btnChangeOwnerClick.bind(this, this.state.NewOwner)}> Change Owner </button>}
                    </p>
             

                  </ul>
                </div>

              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
